/* @flow strict */

import * as React from 'react';
import CheckInEventUsers from './users';
import CheckInEventHistory from './history';
import CheckInEventStats from './stats';
import { Link } from 'react-router-dom';

type PropsType = {
    eventId: string | number,
    eventScheduleId: string | number,
    handleResetEvent: () => void
};

const CheckInEventDetail = ({ eventId, eventScheduleId, handleResetEvent }: PropsType): React.Element<'div'> => {
    const [tab, setTab] = React.useState(1);
    const [checkInUpdated, setCheckInUpdated] = React.useState(false);

    return (
        <div className='check-in-detail_container'>
        <div className='sparxo-navbar'>
            <Link
              to={'/check-in'}
              className="sparxo-navbar-back"
              onClick={handleResetEvent}
            >

                <i className="icon icon-angle-left" />
                <span>back</span>
            </Link>
            </div>
            <div className='check-in-detail_content'>
                    <CheckInEventUsers eventId={eventId} handleCheckInUpdate={(): void => setCheckInUpdated((prev: {}): any => !prev)} />
                <section>
                    <div className='check-in-detail_tabs'>
                        <div
                          className={`check-in-detail_tab ${tab === 1 ? 'active' : ''}`}
                          onClick={(): void => setTab(1)}
                        >
                            History
                        </div>
                        <div className={`check-in-detail_tab ${tab === 2 ? 'active' : ''}`}
                          onClick={(): void => setTab(2)}
                        >
                            Check-in Stats
                        </div>
                    </div>
                    {
                        tab === 1 ?
                            <CheckInEventHistory
                              eventId={eventId}
                              checkInUpdated={checkInUpdated}
                            />
                            :
                            <CheckInEventStats
                              eventId={eventId}
                              eventScheduleId={eventScheduleId}
                              checkInUpdated={checkInUpdated}
                            />
                    }
                </section>
            </div>
        </div>
    );
};

export default CheckInEventDetail;